import { onSubmit, personalizeBullets, save, setResume } from '../../handlers';


export const getASError = (stateProps, formikProps, qid) => {
  let index = stateProps.sectionData.sectionIndex;
  /*if (stateProps.sectionData.sectionType === 'industry') {
    index = stateProps.sectionData.indIndex;
  }*/

  let error = '';
  if (qid === 'industry' && formikProps.values.jobSeekerData[index]['industry']) {
    error = 'REQUIRED *';
  }
  if (qid === 'job_title' && formikProps.values.jobSeekerData[index]['job_title']) {
    error = 'REQUIRED *';
  }
  if (Object.keys(stateProps.asError).length > 0) {
    error = stateProps.asError[qid];
  }
  return error;
};
/**
 *
 * @param newValue
 * @param props
 * @param qObj
 * @param index
 */
export const handleChange = (newValue, props, qObj, index) => {
  /*if(newValue['__isNew__']) {
    newValue.key = 'Other';
  }*/
  const stateProps = props.stateProps;
  const jobSeekerData = props.formikProps.values.jobSeekerData;


  if (stateProps.sectionData.sectionName === 'professional-experience' &&
    (typeof jobSeekerData[index]['industry'] !== 'undefined' && newValue.key !== jobSeekerData[index]['industry'])) {
    if (qObj.qid === 'job_title_choice' && jobSeekerData[0]['job_title_choice'] !== newValue.value) {
      props.formikProps.values.jobSeekerData[index]['bulletsb'] = [];
    }
  }

  let newValues = [];
  if (Array.isArray(newValue)) {
    for (const [key, valObj] of Object.entries(newValue)) {
      newValues.push(valObj.value);
      updateOptions(qObj, valObj);
    }
  } else {
    newValues.push(newValue.value);
    updateOptions(qObj, newValue);
  }
  jobSeekerData[index][qObj.qid] = newValues;
  if (qObj.qid === 'Test1') {
    jobSeekerData[index]['industry'] = jobSeekerData[index]['Test1'];
    props.stateProps.onJobIndustryClose();
  }
  onSubmit(props.formikProps, props.stateProps);
  //ALERT change this field value WTF
  if(qObj.qid === 'Test1') {

    save(props.stateProps, index);
  }
  if (props.stateProps.sectionData.sectionName === 'resumes') {
    props.stateProps.dataToSave.saved.resumes[index].industry = newValues;
    setResume(props,index);
  }
  if (props.stateProps.sectionData.sectionName === 'professional-experience'  && qObj.qid === 'Test1') {
    personalizeBullets(props);
  }
};

/**
 *
 * @param inputValue
 */
export const handleInputChange = (e, styles) => {
  styles = {
    option: () => ({
      display: 'none',
      fontFamily: 'Work Sans',
      fontWeight: 600,
      textTransform: 'uppercase',
      padding: '10px 12px',
      margin: '6px',
      cursor: 'pointer',
      ':hover': {
        borderRadius: '4px',
      },
    }),
  };
};

/**
 *
 * @param qObj
 * @returns {boolean|*}
 */
export const isMulti = (qObj) => {
  const isMulti = typeof qObj.multiple === 'undefined' ? false : qObj.multiple;
  return isMulti;
};

/**
 *
 * @param qObj
 * @param jobTitles
 * @param jobTitle
 * @returns {*[]}
 */
const getIndustryOptions = (qObj, jobTitles, jobTitle) => {
  let industryOptions = [];
  const removed = [];
  if (qObj.seeMore) {
    for (let option of qObj.indOptions) {
      for (let job of jobTitles) {
        if (job.industry === option.value && jobTitle === job.value) {
          const removedObj = option;
          removed.push(removedObj);
        }
      }
    }
    industryOptions = removed.concat(qObj.indOptions);
  } else {
    for (let option of qObj.indOptions) {
      for (let job of jobTitles) {
        if (job.industry === option.value && jobTitle === job.value) {
          const removedObj = option;
          removed.push(removedObj);
        }
      }
    }
    removed.push({ key: 'seemore', label: 'See More', value: 'seemore' });
    industryOptions = removed;
  }
  return industryOptions;
};


/**
 *
 * @param props
 * @param qObj
 * @param index
 */
export const getOptions = (props, qObj, index) => {
  const jobTitles = props.survey.section.resumes.question_parts[0].options;
  const jobTitle = props.formikProps.values.jobSeekerData[index]['job_title'];
  if (typeof jobTitle !== 'undefined') {
    qObj.options = getIndustryOptions(qObj, jobTitles, jobTitle[0]);
  }
};
/**
 *
 * @param field
 * @returns {*[]}
 */
export const getFValue = (field) => {
  let fValue = [];
  if (typeof field.value !== 'undefined') {
    fValue = field.value;
    if (!Array.isArray(fValue)) {
      fValue = [fValue];
    }
  }
  return fValue;
};
/**
 *
 * @param fValue
 * @param option
 * @param selected
 * @returns {*}
 */
export const setSelected = (fValue, option, selected) => {
  fValue.forEach((value) => {
    if (option.value === value) {
      selected.push(option);
    }
  });
  return selected;
};
/**
 *
 * @param qObj
 * @param field
 * @returns {*[]}
 */
export const init = (qObj, field) => {
  let isOther = true;
  for (const option of qObj.options) {
    if (field.value && Array.isArray(field.value) && option.value === field.value[0]) {
      isOther = false;
      break;
    }
  }
  if (isOther && field.value) {
    qObj.options.push(
      {
        key: field.value[0],
        label: field.value[0],
        value: field.value[0],
      },
    );
  }
  const fValue = getFValue(field);
  let selected = [];

  qObj.options.forEach((option) => {
    selected = setSelected(fValue, option, selected);
  });
  return selected;
};

/**
 *
 * @param qObj
 * @param valObj
 */
const updateOptions = (qObj, valObj) => {
  let doesExist = false;
  for (let i = 0; i < qObj.options.length; i++) {
    let option = qObj.options[i];
    if (valObj.value === option.value) {
      doesExist = true;
      break;
    }
  }
  if (!doesExist) {
    qObj.options.push({
      label: valObj.value,
      key: valObj.value,
      value: valObj.value,
      isNew: true,
    });
  }
};